import qs from 'query-string'
import { ORDER_OPTIONS } from './constants'
import { SEARCH_FILTER_BOARD_TYPES } from '@s4l/stayforlong/property/domain/ListOfBoard'
import { PAYMENT_OPTIONS } from '@s4l/stayforlong/property/domain/PaymentOption'
import { CANCELLATION_POLICIES } from '@s4l/stayforlong/property/domain/CancellationPolicy'

function validateFilterUrlParam(param: string, data: string | string[] | null): data is string {
  if (!param || !data || typeof data !== 'string') {
    return false
  }

  const dataArray = data.split(',')

  switch (param) {
    case 'stars':
      return dataArray.every(item => {
        const currentStarValue = Number.parseInt(item, 10)
        return currentStarValue > 0 && currentStarValue <= 5
      })
    case 'facilities': {
      return dataArray.every(item => {
        const formattedItem = item.replace('-', '').toLocaleLowerCase()
        const names = [
          'carpark',
          'gym',
          'indoorpool',
          'outdoorpool',
          'airportshuttle',
          'spa',
          'wifi',
          'wheelchair',
        ]
        return names.includes(formattedItem)
      })
    }
    case 'accommodationTypes': {
      return dataArray.every(item => {
        const formattedItem = item.replace('-', '').toLocaleLowerCase()
        const slugs = ['hotel', 'apartment', 'villa', 'homes', 'hostel', 'resort', 'apthotel']

        return slugs.includes(formattedItem)
      })
    }
    case 'themes': {
      return dataArray.every(item => {
        const validThemeSlugs = ['family', 'spa', 'business', 'pet-friendly', 'romantic']

        return validThemeSlugs.includes(item)
      })
    }
    case 'boards': {
      return dataArray.every(item =>
        (SEARCH_FILTER_BOARD_TYPES as readonly string[]).includes(item)
      )
    }
    case 'paymentOptions': {
      return dataArray.every(item => (PAYMENT_OPTIONS as readonly string[]).includes(item))
    }
    case 'cancellationPolicies': {
      return dataArray.every(item => (CANCELLATION_POLICIES as readonly string[]).includes(item))
    }
    case 'minPrice':
      return Number.parseInt(data, 10) >= 0
    case 'maxPrice':
      return Number.parseInt(data, 10) > 0
    case 'ratings':
      return dataArray.every(item => {
        const currentStarValue = Number.parseInt(item, 10)
        return currentStarValue > 0 && currentStarValue <= 10
      })
    case 'family':
      return data === 'true'
    case 'orderBy':
      return ORDER_OPTIONS.includes(data)
    default:
      return false
  }
}

export function getValidFiltersFromUrl(queryString?: string) {
  if (!queryString) {
    return {}
  }

  const filters: Record<string, string> = {}
  const params = qs.parse(queryString)
  const paramKeys = Object.keys(params)
  const paramsLength = paramKeys.length

  for (let i = 0; i < paramsLength; i += 1) {
    const filterName = paramKeys[i]
    const paramValue = params[filterName]
    if (validateFilterUrlParam(filterName, paramValue)) {
      filters[filterName] = paramValue
    }
  }

  return filters
}
